import styled from "styled-components";
//import Variables from "../../assets/styleVariables";

export const SettingContainer = styled.div`
  margin-top: 64px;
  height: calc(100vh - 64px);
  margin-right: 256px;
  position: relative;
`;
export const SettingInnerContainer = styled.div`
  width: 100%;
  padding: 60px 90px;
  height: inherit;
  overflow-y: auto;
`;

